import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEvaluation } from '../../hooks/useEvaluation';
import { GaugeChart } from '../../components/charts/GaugeChart';
const CARD_STYLE = {
    position: 'relative',
    backgroundColor: '#141414',
    border: '2px solid #333333',
    borderRadius: 0,
    padding: '1rem 1.25rem',
    marginBottom: '0.75rem',
    maxWidth: '600px',
    marginLeft: 'auto',
    marginRight: 'auto',
};
const SECTION_TITLE = {
    fontWeight: '900',
    color: '#999999',
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
    fontSize: '12px',
    marginBottom: '12px',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
};
const CONTENT_STYLE = {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    alignItems: 'center',
};
const HEADER_STYLE = {
    marginBottom: '0.5rem',
    textAlign: 'center',
    maxWidth: '512px',
    width: '100%',
};
const TITLE_STYLE = {
    fontSize: '1.25rem',
    fontWeight: '900',
    color: '#f5f5f5',
    textTransform: 'uppercase',
    letterSpacing: '-0.025em',
    marginBottom: '0.25rem',
};
const SUBTITLE_STYLE = {
    fontSize: '0.875rem',
    color: '#999999',
};
const BUTTON_PRIMARY = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#06b6d4',
    color: '#000000',
    fontWeight: '900',
    border: '2px solid #06b6d4',
    borderRadius: 0,
    padding: '10px 20px',
    fontFamily: 'inherit',
    fontSize: '13px',
    letterSpacing: '0.02em',
    textTransform: 'uppercase',
    transition: 'all 0.15s ease',
    cursor: 'pointer',
};
const BUTTON_SECONDARY = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    color: '#f5f5f5',
    fontWeight: '900',
    border: '2px solid #333333',
    borderRadius: 0,
    padding: '10px 20px',
    fontFamily: 'inherit',
    fontSize: '13px',
    letterSpacing: '0.02em',
    textTransform: 'uppercase',
    transition: 'all 0.15s ease',
    cursor: 'pointer',
};
const LIST_ITEM_STYLE = {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    padding: '0.75rem',
    borderBottom: '1px solid #333333',
    transition: 'background-color 0.15s ease',
};
const PROGRESS_BAR_STYLE = {
    height: '8px',
    backgroundColor: '#2a2a2a',
    borderRadius: 0,
    overflow: 'hidden',
    width: '128px',
};
const PROGRESS_FILL_STYLE = (sfp) => ({
    height: '100%',
    width: `${sfp * 10}%`,
    backgroundColor: sfp >= 7 ? '#22c55e' : sfp >= 5 ? '#f59e0b' : '#ef4444',
    transition: 'width 0.3s ease',
});
const GRID_ITEM_STYLE = {
    textAlign: 'center',
    padding: '1rem',
    backgroundColor: '#141414',
    border: '1px solid #333333',
};
export function EvaluateTab() {
    const { evaluate } = useEvaluation();
    const scores = evaluate();
    if (!scores || scores.length === 0) {
        return (_jsx("div", { style: CONTENT_STYLE, children: _jsxs("div", { style: HEADER_STYLE, children: [_jsx("h2", { style: TITLE_STYLE, children: "Avalia\u00E7\u00E3o dos Modelos" }), _jsx("p", { style: SUBTITLE_STYLE, children: "Nenhuma avalia\u00E7\u00E3o dispon\u00EDvel." })] }) }));
    }
    const topScore = scores[0];
    const allTop = scores.slice(0, 5);
    const rest = scores.slice(5);
    return (_jsxs("div", { style: CONTENT_STYLE, children: [_jsxs("div", { style: HEADER_STYLE, children: [_jsx("h2", { style: TITLE_STYLE, children: "Avalia\u00E7\u00E3o dos Modelos" }), _jsx("p", { style: SUBTITLE_STYLE, children: "Baseado no seu perfil e pesos selecionados." })] }), _jsx("div", { style: CARD_STYLE, children: _jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: '1.5rem' }, children: [_jsx(GaugeChart, { value: topScore.sfp, label: "SFP", size: 120 }), _jsxs("div", { style: { flex: 1 }, children: [_jsx("h3", { style: { fontSize: '1.5rem', fontWeight: '900', color: '#f5f5f5', textTransform: 'uppercase', letterSpacing: '-0.025em', marginBottom: '0.5rem' }, children: topScore.modelId }), _jsx("p", { style: { fontSize: '0.875rem', color: '#999999', marginBottom: '0.75rem' }, children: "Melhor modelo para seu perfil" }), _jsx("p", { style: { fontSize: '0.875rem', color: '#999999', lineHeight: 1.6 }, children: topScore.recommendation })] })] }) }), _jsxs("div", { style: CARD_STYLE, children: [_jsx("h3", { style: SECTION_TITLE, children: "TOP 5 MODELOS" }), _jsx("div", { style: { display: 'flex', flexDirection: 'column' }, children: allTop.map((s, i) => (_jsxs("div", { style: LIST_ITEM_STYLE, onMouseEnter: (e) => e.currentTarget.style.backgroundColor = '#1a1a1a', onMouseLeave: (e) => e.currentTarget.style.backgroundColor = 'transparent', children: [_jsx("span", { style: { fontFamily: 'monospace', fontWeight: '900', color: '#06b6d4', width: '32px', textAlign: 'right' }, children: String(i + 1).padStart(2, '0') }), _jsx("span", { style: { flex: 1, fontWeight: '900', color: '#f5f5f5' }, children: s.modelId }), _jsx("span", { style: { fontFamily: 'monospace', fontWeight: '900', color: '#fbbf24' }, children: s.sfp.toFixed(1) }), _jsx("div", { style: PROGRESS_BAR_STYLE, children: _jsx("div", { style: PROGRESS_FILL_STYLE(s.sfp) }) })] }, s.modelId))) })] }), rest.length > 0 && (_jsxs("div", { style: CARD_STYLE, children: [_jsx("h3", { style: SECTION_TITLE, children: "OUTROS MODELOS" }), _jsx("div", { style: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: '0.5rem' }, children: rest.map((s) => (_jsxs("div", { style: GRID_ITEM_STYLE, children: [_jsx("div", { style: { fontWeight: '900', color: '#f5f5f5', fontSize: '13px' }, children: s.modelId }), _jsx("div", { style: { fontFamily: 'monospace', fontWeight: '900', color: '#06b6d4', fontSize: '2rem', marginTop: '0.5rem' }, children: s.sfp.toFixed(1) })] }, s.modelId))) })] }))] }));
}
